import React from "react";

function XIcon({ disabled = false }) {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0306 11.97C13.1715 12.1109 13.2506 12.302 13.2506 12.5012C13.2506 12.7005 13.1715 12.8916 13.0306 13.0325C12.8897 13.1734 12.6986 13.2525 12.4993 13.2525C12.3001 13.2525 12.109 13.1734 11.9681 13.0325L7.99997 9.0631L4.0306 13.0312C3.8897 13.1721 3.69861 13.2513 3.49935 13.2513C3.30009 13.2513 3.10899 13.1721 2.9681 13.0312C2.8272 12.8903 2.74805 12.6992 2.74805 12.5C2.74805 12.3007 2.8272 12.1096 2.9681 11.9687L6.93747 8.0006L2.96935 4.03122C2.82845 3.89033 2.7493 3.69923 2.7493 3.49997C2.7493 3.30072 2.82845 3.10962 2.96935 2.96872C3.11024 2.82783 3.30134 2.74867 3.5006 2.74867C3.69986 2.74867 3.89095 2.82783 4.03185 2.96872L7.99997 6.9381L11.9693 2.9681C12.1102 2.8272 12.3013 2.74805 12.5006 2.74805C12.6999 2.74805 12.891 2.8272 13.0318 2.9681C13.1727 3.10899 13.2519 3.30009 13.2519 3.49935C13.2519 3.69861 13.1727 3.8897 13.0318 4.0306L9.06247 8.0006L13.0306 11.97Z"
          fill={disabled ? "#9CA3AF" : "#EF3352"}
        />
      </svg>
    </>
  );
}

export default XIcon;
